import { Controller } from "@hotwired/stimulus"
import {
  Chart,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

// 2. Register the components
// Without this step, Chart.js won't know how to render bars or axes
Chart.register(
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

Chart.defaults.backgroundColor = 'hsl(167, 60%, 70%)';
// Chart.defaults.borderColor = 'hsl(167, 80%, 40%)';
Chart.defaults.color = '#414141';

export default class extends Controller {
  static targets = ['canvas']
  static values = {
    data: Object,
    yAxisPrefix: String
  }
  connect() {
    this.buildConfig();
    this.chart = new Chart(this.canvasTarget, this.config);
  }

  disconnect() {
    this.chart.destroy();
  }

  buildConfig() {
    this.config = {
      type: 'bar',
      data: this.dataValue,
      options: {
        responsive: true,
        maintainAspectRatio: false,
      }
    }
    if (this.hasYAxisPrefixValue && this.yAxisPrefixValue !== '') {
      this.config.options.scales = {
        y: {
          ticks: {
            callback: (value) => `${this.yAxisPrefixValue}${value}`
          }
        }
      };
    }
  }
}
